<div class="fast-search__input-wrapper">
  <div class="fast-search__input-icon">
    <svg
      width="14px"
      height="14px"
      viewBox="0 0 14 14"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Assets"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        transform="translate(-66.000000, -335.000000)"
      >
        <path
          d="M75.2024582,338.026142 C73.4965685,336.320252 70.7320314,336.320252 69.0261418,338.026142 C67.3202521,339.732031 67.3202521,342.496569 69.0261418,344.202458 C70.7320314,345.908348 73.4965685,345.908348 75.2024582,344.202458 C76.9083479,342.496569 76.9083479,339.732031 75.2024582,338.026142 M79.7445096,348.74451 C79.4029823,349.085163 78.8500749,349.085163 78.5085475,348.74451 L75.757986,345.993075 C73.3629274,347.783691 69.9668705,347.614238 67.7910532,345.437547 C65.4029823,343.050349 65.4029823,339.179124 67.7910532,336.791053 C70.1782506,334.402982 74.0503494,334.402982 76.4375468,336.791053 C78.6142376,338.96687 78.783691,342.362927 76.9930746,344.757986 L79.7445096,347.509421 C80.0851635,347.850075 80.0851635,348.402982 79.7445096,348.74451"
          id="Search"
          fill="#DFE3E9"
        ></path>
      </g>
    </svg>
  </div>

  <input
    type="text"
    id="search-input"
    class="fast-search__input"
    [class.fast-search__input_focused]="focused"
    placeholder="Поиск"
    [ngModel]="searchText()"
    (ngModelChange)="onSearchChange($event)"
    (keyup)="keyUp$.next($event)"
    (focus)="focused = true"
    (blur)="focused = false"
    autocomplete="off"
    aria-label="Поиск"
  />
</div>
